import { render, staticRenderFns } from "./ModalTicket.vue?vue&type=template&id=680def4e"
import script from "./ModalTicket.vue?vue&type=script&lang=js"
export * from "./ModalTicket.vue?vue&type=script&lang=js"
import style0 from "./ModalTicket.vue?vue&type=style&index=0&id=680def4e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680def4e')) {
      api.createRecord('680def4e', component.options)
    } else {
      api.reload('680def4e', component.options)
    }
    module.hot.accept("./ModalTicket.vue?vue&type=template&id=680def4e", function () {
      api.rerender('680def4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/payment/details/components/ModalTicket.vue"
export default component.exports